import React from 'react';
import { useWebLocale } from '../../contexts/WebLocaleContext';
import { playlistText } from '../../app-ui/baseline';

export default function PlaylistListState({ query, children, hideNextError = false }) {
  const { locale } = useWebLocale();
  const error = query.isError && !(hideNextError && query.isFetchNextPageError);
  return (
    <>
      {error && (
        <div role="alert" className="pp-browse-list-status">
          <span>{playlistText(locale, 'listLoadError')}</span>
          <button
            className="pp-action"
            disabled={query.isFetching}
            onClick={() => query.refetch({ cancelRefetch: false })}
          >
            {locale === 'en' ? 'Retry' : '다시 시도'}
          </button>
        </div>
      )}
      {query.isPending && <p role="status">{locale === 'en' ? 'Loading…' : '불러오는 중…'}</p>}
      {query.data && children}
    </>
  );
}
